module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('shop-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.params.distributor_id
    },
    on: {
      "update": _vm.storeSearch
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "placeholder": "商品名称",
      "size": "mini"
    },
    model: {
      value: (_vm.goodsName),
      callback: function($$v) {
        _vm.goodsName = $$v
      },
      expression: "goodsName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "运费模板"
    },
    on: {
      "change": _vm.handleChangeTemplates
    },
    model: {
      value: (_vm.templates_id),
      callback: function($$v) {
        _vm.templates_id = $$v
      },
      expression: "templates_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.login_type == 'distributor') ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button-group', [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": _vm.addItems
    }
  }, [_vm._v("添加商品")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("更改商品分类")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.addTemplates
    }
  }, [_vm._v("更改运费模板")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [(_vm.activeName == 'second') ? _c('div', {
      staticStyle: {
        "margin-bottom": "15px",
        "width": "280px"
      }
    }, [_c('el-input', {
      attrs: {
        "value": "warning_store"
      },
      model: {
        value: (_vm.warning_store),
        callback: function($$v) {
          _vm.warning_store = $$v
        },
        expression: "warning_store"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("预警数量")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "append"
      },
      on: {
        "click": _vm.setWarningStore
      },
      slot: "append"
    }, [_vm._v("保存")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList,
        "height": _vm.wheight - 280
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goods_id",
        "label": "商品ID",
        "min-width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "排序编号",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "mini"
            },
            on: {
              "change": function($event) {
                return _vm.editItemsSort(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.sort),
              callback: function($$v) {
                _vm.$set(scope.row, "sort", $$v)
              },
              expression: "scope.row.sort"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "itemName",
        "label": "商品名称",
        "min-width": "240"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "price",
        "label": "价格",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.itemId !== _vm.currentId) ? _c('div', [_vm._v("\n                ¥" + _vm._s(scope.row.price) + "\n                "), _c('i', {
            staticClass: "el-input__icon el-icon-edit",
            on: {
              "click": function($event) {
                return _vm.editPrice(scope.row.itemId, scope.row.price)
              }
            }
          })]) : _c('el-input', {
            ref: 'input_' + scope.row.itemId,
            refInFor: true,
            attrs: {
              "size": "mini"
            },
            on: {
              "blur": function($event) {
                return _vm.handleBlur(scope.$index)
              }
            },
            model: {
              value: (_vm.currentPrice),
              callback: function($$v) {
                _vm.currentPrice = $$v
              },
              expression: "currentPrice"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store",
        "label": "库存",
        "min-width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "状态",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status == 'onsale') ? _c('span', [_vm._v("前台可销")]) : (scope.row.approve_status == 'offline_sale') ? _c('span', [_vm._v("可线下销售")]) : (scope.row.approve_status == 'only_show') ? _c('span', [_vm._v("前台仅展示")]) : _c('span', [_vm._v("不可销售")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "min-width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "operating-icons"
          }, [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "size": "mini",
              "icon": "edit",
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.itemsDetail(scope.$index, scope.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "size": "mini",
              "icon": "edit",
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editItemsAction(scope.$index, scope.row, false)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "size": "mini",
              "icon": "edit",
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteItemsAction(scope.$index, scope.row)
              }
            }
          }, [_vm._v("删除")])], 1)]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "good-detail-dialog",
    attrs: {
      "title": "商品详情",
      "visible": _vm.ItemsDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ItemsDetailVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("商品名称")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.itemsDetailData.item_name))])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("简述")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.itemsDetailData.brief))])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("价格")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("￥" + _vm._s(_vm.itemsDetailData.price))])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("原价")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("￥" + _vm._s(_vm.itemsDetailData.market_price / 100))])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("库存")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.itemsDetailData.store))])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("状态")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [(_vm.itemsDetailData.approve_status === 'onsale') ? _c('div', {
      staticClass: "grid-content"
    }, [_vm._v("\n              前台可销售\n            ")]) : (_vm.itemsDetailData.approve_status === 'offline_sale') ? _c('div', {
      staticClass: "grid-content"
    }, [_vm._v("\n              可线下销售\n            ")]) : _c('div', {
      staticClass: "grid-content"
    }, [_vm._v("\n              不可销售\n            ")])])], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("图片")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_c('div', {
      staticClass: "block"
    }, [_c('el-carousel', {
      attrs: {
        "height": "200px",
        "width": "375px",
        "autoplay": true,
        "indicator-position": "outside"
      }
    }, [(_vm.itemsDetailData.pics) ? _vm._l((_vm.itemsDetailData.pics), function(pic) {
      return _c('el-carousel-item', {
        key: pic,
        style: ({
          backgroundImage: 'url(' + _vm.wximageurl + pic + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        })
      })
    }) : _vm._e()], 2)], 1)])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("详情")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content grid-detail",
      domProps: {
        "innerHTML": _vm._s(_vm.itemsDetailData.intro)
      }
    })])], 1), _vm._v(" "), (_vm.itemsDetailData.enable_agreement) ? _c('el-row', [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("购买协议")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content grid-detail",
      domProps: {
        "innerHTML": _vm._s(_vm.itemsDetailData.purchase_agreement)
      }
    })])], 1) : _vm._e()], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer content-center",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.ItemsDetailVisible = false;
          _vm.itemsDetailData = {}
        }
      }
    }, [_vm._v("取消")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改运费模板",
      "visible": _vm.addTemplatesdialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplatesdialogVisible = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "运费模板"
    },
    model: {
      value: (_vm.templates_new_id),
      callback: function($$v) {
        _vm.templates_new_id = $$v
      },
      expression: "templates_new_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTemplatesdialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeTemplates
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改商品分类",
      "visible": _vm.addCategorydialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addCategorydialogVisible = $event
      }
    }
  }, [_c('treeselect', {
    attrs: {
      "options": _vm.categoryList,
      "multiple": true,
      "show-count": true,
      "disable-branch-nodes": true
    },
    model: {
      value: (_vm.category_id),
      callback: function($$v) {
        _vm.category_id = $$v
      },
      expression: "category_id"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addCategorydialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeCategory
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b07fde0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b07fde0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/shopselftlist.vue
// module id = 2798
// module chunks = 0